"use client";

import type { LocationSearchFormBreakpoint } from "~www/components/LocationSearchForm/LocationSearchForm";

import { cn } from "@homeinstead/ui";
import { useRouter } from "next/navigation";
import LocationSearchForm from "~www/components/LocationSearchForm/LocationSearchForm";

interface SearchAreaProps {
  heading: string;
  className?: string;
  headingClassName?: string;
  buttonText?: string;
  placeholder?: string;
  showCurrentLocation?: boolean;
  targetUrl?: string;
  horizontalBreakpoint?: LocationSearchFormBreakpoint;
  defaultQuery?: string;
}

export function SearchArea({
  heading,
  className,
  headingClassName,
  buttonText = "Find a Local Office",
  placeholder,
  showCurrentLocation = true,
  targetUrl,
  horizontalBreakpoint,
  defaultQuery,
}: SearchAreaProps) {
  const router = useRouter();
  const handleSubmit = (place: string) => {
    router.push(`${targetUrl || ""}?q=${encodeURIComponent(place)}`);
  };

  return (
    <div className={cn("flex w-full flex-col gap-6 lg:gap-10", className)}>
      <h1
        className={cn(
          "font-bold font-jakarta text-new-beginnings-base leading-[56px]",
          "text-xl md:text-1xl",
          headingClassName,
        )}
      >
        {heading}
      </h1>

      <LocationSearchForm
        buttonText={buttonText}
        defaultValue={defaultQuery}
        horizontalBreakpoint={horizontalBreakpoint}
        onSubmit={handleSubmit}
        placeholder={placeholder}
        showCurrentLocation={showCurrentLocation}
      />
    </div>
  );
}
